import {disableBodyScroll} from "../sb/disableBodyScroll";

const $ = window.jQuery

const body = $('body')
const searchOpener = $('#js-searchOpen')
const searchForm = $('#js-searchForm')
const searchInput = searchForm.find('[name=search_api_fulltext]')
const suggestionsContainer = $('#js-searchSuggestions')
const suggestions = $('#js-searchSuggestions .taxonomy-term--name')
const noResult = $('#js-searchSuggestions .js-noResult')

const prepare = (isSearchPage) => {
  searchForm.appendTo(isSearchPage ? $('#js-searchFormContainer') : body)
    .css('display', 'block')
}

const handleSearchOpen = () => {
  searchOpener.on('click', function (e) {
    e.preventDefault()
    toggleSearch()
  })
}

const handleSearchClose = () => {
  $('#js-searchClose').on('click', toggleSearch)
}

const handleEscape = e => {
  if (e.keyCode === 27) {
    toggleSearch()
  }
}

const toggleSearch = e => {
  if (e)
    e.preventDefault()

  searchForm.toggleClass('is-active')
  body.toggleClass('has-search-open')

  if (!body.hasClass('has-search-open')) {
    if (searchInput.data('oldValue').length) {
      searchInput.val(searchInput.data('oldValue'))
    }
    searchInput.blur()
    $(document).off('keydown', handleEscape)
    $('.nav-opener').off('click', toggleSearch)
    $.scrollify.enable()
    disableBodyScroll(false)
    suggestionsContainer.css('height', 0)
    // suggestions.each((i, el) => $(el).css('display', 'none'))
    noResult.addClass('u-hidden')
  }
  else {
    searchInput.focus()
    $(document).on('keydown', handleEscape)
    $('.nav-opener').on('click', toggleSearch)
    $.scrollify.disable()
    disableBodyScroll(true, '#js-searchSuggestions')
    suggestionsContainer.css('height', $(window).height() - suggestionsContainer.offset().top)
  }
}
const handleSearchSuggestion = () => {
  let hadResults = false
  searchInput.on('keyup', function () {
    const val = this.value.toLowerCase()
    let hasResults = false
    suggestions.each(function (i, el) {
      const suggestion = $(el)
      if (val === '') {
        suggestion.css('display', 'none')
      }
      else {
        if (suggestion.data('name').toLowerCase().indexOf(val) !== -1) {
          hasResults = true
          hadResults = true
          suggestion.css('display', 'block')
        }
        else {
          suggestion.css('display', 'none')
        }
      }
    })
    noResult.toggleClass('u-hidden', hasResults || (val === '' && hadResults))
  })
}


export const init = () => {
  const isSearchPage = $('body').hasClass('path--search')
  prepare(isSearchPage)

  if (isSearchPage) {
    let hasOldValue = false
    searchInput.on('focus', function() {
      if (!$('body').hasClass('has-search-open')) {
        toggleSearch()
        searchInput.select()
        if (!hasOldValue) {
          $(this).data('oldValue', this.value)
          hasOldValue = true
          searchInput.trigger('keyup')
        }
      }
    })
    $(document).on('click', function (e) {
      if (!$(e.target).closest('#js-searchSuggestions') || !$(e.target).closest('#js-searchForm')) {
        toggleSearch()
      }
    })
  }
  handleSearchOpen()

  handleSearchClose()
  handleSearchSuggestion()

}



//////////////////
// WEBPACK FOOTER
// ./src/js/components/search.js
// module id = 19
// module chunks = 0